module.exports = __webpack_public_path__ + "img/自定义昵称.cae35c50.png";